import { Routes } from 'src/Routes.constants';

export const useDefaultRoutingPath = () => {
  return Routes.dashboard;
};
